export const createSampleBatchMutation = `
mutation createSampleBatch($input: CreateSampleBatchInput!) {
    createSampleBatch(input: $input) {
        batchId
    },
}
`;

export const createCryoboxMutation = `
mutation createCryobox($input: CreateCryoboxInput!) {
    createCryobox(input: $input) {
        serialNo
    },
}
`;

export const updateCryoboxMutation = `
mutation updateCryobox($input: UpdateCryoboxInput!) {
    updateCryobox(input: $input) {
        aliquotPositions
        bioBanked
        createdBy
        createdTs
        freezer {
        freezerId
        name
        serialNo
        temp
        }
        freezerShelfNo
        height
        lastUpdatedBy
        rackPositionNo
        sampleType
        serialNo
        shelfRackNo
        updatedTs
        width
    },
}
`;
